import { createUseStyles } from "react-jss";
import breakpoints from "assets/breakpoints";
import search_input_icn from "assets/images/search_input_icn.svg";
export const useStyles = createUseStyles({
  orglist__page: {
    // headerCommon
    "& .headerCommon": {
      "& .btn-link": {
        "&:hover": {
          textDecoration: "none",
        },
      },
    },
    // odp__search
    "& .odp__search": {
      padding: "17px 10px",
      backgroundColor: "rgb(var(--brand__dark))",
      "& .container-xxl": {
        [breakpoints.SCREEN_XXLM_MAX]: {
          maxWidth: "100%",
          padding: "0",
        },
        "& .form__row": {
          gap: "4px",
          justifyContent: "center",
          "& .fr__items": {
            "& .fr__ibox": {
              height: "46px",
              "& > button": {
                minHeight: "46px",
                "&:hover": {
                  "& > svg": {
                    animation: "org__pop 0.4s linear infinite",
                  },
                },
              },
            },
            "&.fr__pathway, &.fr__spathway, &.fr__keyword, &.fr__county": {
              maxWidth: "260px",
              backgroundColor: "rgb(var(--white))",
              borderRadius: "50rem",
              paddingInline: "14px",
              [breakpoints.SCREEN_LG_MAX]: {
                flex: "0 0 49%",
                maxWidth: "unset !important",
              },
              [breakpoints.SCREEN_SM_MAX]: {
                flex: "0 0 100%",
              },
            },
            "&.fr__orgname": {
              maxWidth: "220px",
              backgroundColor: "rgb(var(--white))",
              borderRadius: "50rem",
              paddingInline: "14px",
              [breakpoints.SCREEN_LG_MAX]: {
                flex: "0 0 49%",
                maxWidth: "unset !important",
              },
              [breakpoints.SCREEN_SM_MAX]: {
                flex: "0 0 100%",
              },
            },
            "&.fr__action": {
              [breakpoints.SCREEN_LG_MAX]: {
                flex: "0 0 49%",
                maxWidth: "unset !important",
              },
              [breakpoints.SCREEN_SM_MAX]: {
                flex: "0 0 100%",
              },
              [breakpoints.SCREEN_MDS_MAX]: {
                marginTop: "5px",
              },
              "& .fr__ibox": {
                width: "100%",
                "& > button": {
                  width: "100%",
                },
              },
            },
          },
        },
      },
    },
    // orgl__section
    "& .orgl__section": {
      paddingBlock: "24px",
      backgroundColor: "rgb(var(--silver))",
      "& .orgl__list": {
        "& .orgl__left": {
          "& .orgll__inner": {
            position: "sticky",
            top: "14px",
            transition: "all 0.3s ease-in-out",
            [breakpoints.SCREEN_LG_MIN]: {
              overflow: "hidden",
            },
            [breakpoints.SCREEN_LG_MAX]: {
              top: "unset",
              bottom: "0",
              right: "0",
              left: "0",
              border: "0",
              zIndex: "99",
              width: "100%",
              position: "fixed",
              overflow: "auto hidden",
              transform: "translateY(102%)",
              WebkitTransform: "translateY(102%)",
              height: "100dvh",
              backgroundColor: "rgb(var(--white))",
            },
            "&.active": {
              [breakpoints.SCREEN_LG_MAX]: {
                transform: "translateY(0)",
                WebkitTransform: "translateY(0)",
              },
            },
            "& .card__lbox": {
              [breakpoints.SCREEN_LG_MIN]: {
                border: "1px solid rgb(var(--light))",
                borderRadius: "8px",
                boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
              },
              // cb__title
              "& .cb__title": {
                borderBottom: "1px solid rgb(var(--light))",
                [breakpoints.SCREEN_LG_MIN]: {
                  padding: "16px",
                },
                [breakpoints.SCREEN_LG_MAX]: {
                  padding: "10px 12px",
                },
                "& p": {
                  fontSize: "15px",
                  lineHeight: "1.3",
                  "& > br": {
                    [breakpoints.SCREEN_LG_MAX]: {
                      display: "none",
                    },
                  },
                },
                "& .cbt__end": {
                  "& .afUndo": {
                    "& > svg": {
                      "& > path": {
                        color: "rgb(var(--danger))",
                      },
                    },
                  },
                  "& .afCE": {
                    opacity: ".50",
                    transition: "transform 0.2s ease-in-out",
                    transform: "rotate(0deg)",
                    WebkitTransform: "rotate(0deg)",
                    "&.active": {
                      transform: "rotate(-180deg)",
                      WebkitTransform: "rotate(-180deg)",
                    },
                  },
                },
              },
              // accordion
              "& .cb__body": {
                overflow: "hidden auto",
                [breakpoints.SCREEN_LG_MIN]: {
                  maxHeight: "calc(100dvh - 300px)",
                  minHeight: "300px",
                },
                "& .accordion": {
                  boxShadow: "none",
                  "&:not(:last-child)": {
                    borderBottom: "1px solid rgb(var(--light))",
                  },
                  "& .accordion-item": {
                    border: "0",
                    boxShadow: "none",
                    "& .accordion-header": {
                      position: "relative",
                      [breakpoints.SCREEN_LG_MIN]: {
                        padding: "16px",
                      },
                      [breakpoints.SCREEN_LG_MAX]: {
                        padding: "10px 12px",
                      },
                      "&.filtered": {
                        "&:after": {
                          content: '""',
                          width: "6px",
                          height: "6px",
                          borderRadius: "50rem",
                          backgroundColor: "rgb(var(--success))",
                          position: "absolute",
                          top: "6px",
                          right: "6px",
                        },
                      },
                      "& .accordion-button": {
                        border: "0",
                        boxShadow: "none",
                        padding: "0",
                        fontSize: "14px",
                        fontWeight: "var(--fw-500)",
                        color: "rgb(var(--dark))",
                        backgroundColor: "transparent",
                        "&:after": {
                          width: "14px",
                          height: "14px",
                          opacity: "0.7",
                          backgroundSize: "14px",
                        },
                        "&:focus": {
                          boxShadow: "none",
                        },
                        "& > span": {
                          fontSize: "15px",
                        },
                      },
                    },
                    "& .accordion-collapse": {
                      border: "0",
                      "& .accordion-body": {
                        border: "0",
                        padding: "0",
                        paddingInlineEnd: "16px",
                        "& .acco__search": {
                          paddingInlineStart: "16px",
                          "& > input": {
                            padding: "8px 12px 8px 36px",
                            backgroundImage: `url(${search_input_icn})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center left 12px",
                            borderColor: "rgb(var(--light))",
                            "&:focus, &:focus-visible": {
                              boxShadow: "0 0 0 .25rem rgb(var(--dark) / 0.04)",
                            },
                          },
                        },
                        "& .acco__list": {
                          maxHeight: "270px",
                          overflowY: "auto",
                          paddingInlineStart: "16px",
                          "& .checkBox": {
                            "&:not(:last-child)": {
                              marginBottom: "6px",
                            },
                            "& .form-check": {
                              "& > input": {
                                width: "18px",
                                height: "18px",
                                "&:checked": {
                                  backgroundColor: "rgb(var(--dark))",
                                  borderColor: "rgb(var(--dark))",
                                  "& ~ .form-check-label": {
                                    color: "rgb(var(--dark))",
                                    opacity: "1",
                                  },
                                },
                                "&:focus": {
                                  borderColor: "rgb(var(--dark) / 0.05)",
                                  boxShadow:
                                    "0 0 0 .25rem rgb(var(--dark) / 0.1)",
                                },
                              },
                              "& > label": {
                                fontSize: "14px",
                                cursor: "pointer",
                                color: "rgb(var(--gray))",
                                fontWeight: "var(--fw-500)",
                                lineHeight: "1.2",
                                opacity: "0.9",
                              },
                            },
                          },
                        },
                        "& .acco__btn": {
                          marginTop: "6px",
                          marginBottom: "16px",
                          paddingInlineStart: "40px",
                          "& > button": {
                            fontSize: "14px",
                            minHeight: "auto",
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        "& .orgl__right": {
          "& .card__rbox": {
            "& .card__rtop": {
              marginBottom: "12px",
              "& .sfilters": {
                gap: "4px",
                "& .fs__items": {
                  fontSize: "13px",
                  padding: "8px 10px",
                  fontWeight: "var(--fw-500)",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderColor: "rgb(var(--light))",
                  boxShadow: "0 0 12px rgb(var(--black) / 0.02)",
                  "&:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5)":
                    {
                      "& > span": {
                        display: "block",
                        display: "-webkit-box",
                        maxWidth: "160px",
                        WebkitLineClamp: "1",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      },
                    },
                  "&.fs__moreless": {
                    minWidth: "32px",
                    height: "32px",
                    padding: "4px",
                    fontSize: "12px",
                    "&:hover": {
                      animation: "org__pop 0.4s linear infinite",
                    },
                  },
                  "& .btn-close": {
                    width: "10px",
                    height: "10px",
                    backgroundSize: "10px",
                  },
                },
              },
            },
            "& .card__rbottom": {
              borderRadius: "8px",
              border: "1px solid rgb(var(--light))",
              boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
              "& .card__rfilter": {
                padding: "16px",
                borderBottom: "1px solid rgb(var(--light))",
                "& .card__left": {
                  "& .gl__grp": {
                    padding: "2px 6px",
                    borderRadius: "50rem",
                    fontWeight: "var(--fw-500)",
                    border: "1px solid rgb(var(--light))",
                    boxShadow: "0 0 12px rgb(var(--black) / 0.02)",
                    "& > .gl__items": {
                      width: "42px",
                      flex: "0 0 42px",
                      height: "34px",
                      opacity: "0.40",
                      "&.active": {
                        opacity: "1",
                      },
                    },
                    "& .gl__iline": {
                      width: "1px",
                      height: "20px",
                      backgroundColor: "rgb(var(--light))",
                    },
                  },
                  "& .react-select__control": {
                    fontSize: "14px",
                    minHeight: "40px",
                    paddingLeft: "8px",
                    paddingRight: "4px",
                    borderRadius: "50rem",
                    fontWeight: "var(--fw-500)",
                    borderColor: "rgb(var(--light))",
                    backgroundColor: "rgb(var(--white))",
                    boxShadow: "0 0 12px rgb(var(--black) / 0.02)",
                    "&.react-select__control--is-focused": {
                      boxShadow: "none",
                      "& .react-select__indicators": {
                        "& .react-select__indicator": {
                          "& > svg": {
                            transform: "rotate(180deg);",
                          },
                        },
                      },
                    },
                    "& .react-select__value-container": {
                      paddingRight: "0",
                      "& .react-select__placeholder": {
                        margin: "0",
                        fontSize: "14px",
                        fontWeight: "var(--fw-400)",
                      },
                      "& .react-select__single-value": {
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        margin: "0",
                      },
                    },
                    "& .react-select__indicators": {
                      "& .react-select__indicator-separator": {
                        display: "none",
                      },
                    },
                  },
                  "& .react-select__menu": {
                    boxShadow:
                      "0 0 0 1px rgb(0 0 0 / 6%), 0 4px 11px rgb(0 0 0 / 8%)",
                    "& .react-select__menu-list": {
                      padding: "8px",
                      "& .react-select__option": {
                        fontSize: "14px",
                        cursor: "pointer",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        color: "rgb(var(--gray))",
                        fontWeight: "var(--fw-500)",
                        alignItems: "center",
                        display: "flex",
                        gap: "4px",
                        transition: "all 0.3s ease-in-out",
                        "& > svg": {
                          color: "rgb(var(--yellow))",
                          transition: "all 0.3s ease-in-out",
                        },
                        "&.react-select__option--is-focused": {
                          backgroundColor: "rgb(var(--dark) / 0.06)",
                          color: "rgb(var(--dark))",
                          "& > svg": {
                            color: "rgb(var(--success))",
                          },
                        },
                        "&.react-select__option--is-selected": {
                          backgroundColor: "rgb(var(--success) / 0.10)",
                          color: "rgb(var(--success))",
                          "& > svg": {
                            color: "rgb(var(--success))",
                          },
                        },
                        "&:not(:last-child)": {
                          marginBottom: "1px",
                        },
                      },
                    },
                  },
                },
              },
              "& .card__rolist": {
                [breakpoints.SCREEN_LG_MIN]: {
                  maxHeight: "1036px",
                  overflow: "hidden auto",
                },
                "& .rolist__items": {
                  gap: "14px",
                  padding: "14px",
                  display: "flex",
                  alignItems: "center",
                  transition: "all 0.2s ease-in-out",
                  overflow: "hidden",
                  "&:not(:last-child)": {
                    borderBottom: "1px solid rgb(var(--light))",
                  },
                  "&:hover": {
                    backgroundColor: "#f9f9f9",
                  },
                  "& .rolist__igallary": {
                    display: "flex",
                    position: "relative",
                    "& .click__here": {
                      display: "block",
                      position: "absolute",
                      zIndex: "1",
                      top: "-14px",
                      left: "-14px",
                    },
                    "& .rolist__iimg": {
                      position: "relative",
                      borderRadius: "8px",
                      overflow: "hidden",
                      "& .no__img": {
                        width: "100%",
                        height: "164px",
                        "& > span": {
                          fontSize: "12px",
                        },
                      },
                      "& .sliderCommon": {
                        "& .carousel": {
                          "& .carousel-indicators": {
                            bottom: "6px",
                          },
                          "& .carousel-inner": {
                            height: "164px",
                            "& .carousel-item": {
                              height: "100%",
                            },
                          },
                        },
                      },
                    },
                    "& .rolist__icontent": {
                      "& .icontent__top": {
                        "& .icontent__tpathway": {
                          "& .tpathway__items": {
                            lineHeight: "1.2",
                            "& > span": {
                              fontSize: "13px",
                              display: "inline-flex",
                              alignItems: "center",
                              "&:not(:last-child)": {
                                marginRight: "4px",
                              },
                            },
                          },
                        },
                      },
                      "& .icontent__ttitle": {
                        fontSize: "17px",
                        lineHeight: "1.2",
                        marginBottom: "8px",
                      },
                      "& .icontent__tsubpathway": {
                        marginBottom: "10px",
                        "& .tspathway__items": {
                          lineHeight: "1.2",
                          "& > span": {
                            fontSize: "13px",
                            display: "inline-flex",
                            alignItems: "center",
                            "&:not(:last-child)": {
                              marginRight: "4px",
                            },
                          },
                        },
                      },
                      "& .icontent__taddress": {
                        marginBottom: "10px",
                        padding: "10px 12px",
                        borderRadius: "8px",
                        border: "1px solid rgb(var(--light))",
                        "& svg": {
                          flex: "0 0 14px",
                        },
                        "& span": {
                          fontSize: "13px",
                        },
                      },
                      "& .icontent__tdescription": {
                        fontSize: "14px",
                        "& br": {
                          display: "none",
                        },
                        "& span": {
                          fontSize: "13px",
                          marginLeft: "4px",
                        },
                      },
                    },
                  },
                  "& .rolist__iaction": {
                    width: "180px",
                    "& .iaction__review": {
                      padding: "6px 14px",
                      fontWeight: "var(--fw-500)",
                      border: "1px solid rgb(var(--light))",
                      boxShadow: "0 0 12px rgb(var(--black) / 0.02)",
                      backgroundColor: "rgb(var(--white))",
                      "& span": {
                        fontSize: "14px",
                      },
                      "& svg": {
                        fontSize: "14px",
                        color: "rgb(var(--yellow))",
                      },
                      "&:hover": {
                        "& svg": {
                          animation: "org__pop 0.4s linear infinite",
                        },
                      },
                    },
                    "& .iaction__contact": {
                      "& .contact__items": {
                        width: "44px",
                        height: "44px",
                        border: "1px solid rgb(var(--light))",
                        boxShadow: "0 0 12px rgb(var(--black) / 0.02)",
                        backgroundColor: "rgb(var(--white))",
                        transition: "all 0.3s ease-in-out",
                        "&:hover": {
                          "& svg": {
                            animation: "org__pop 0.4s linear infinite",
                          },
                        },
                      },
                    },
                  },
                },
                // org__list
                "&.org__list": {
                  "& .rolist__items": {
                    "& .rolist__igallary": {
                      gap: "14px",
                      width: "calc(100% - 180px)",
                      paddingRight: "14px",
                      borderRight: "1px solid rgb(var(--light))",
                      "& .click__here": {
                        width: "102%",
                        height: "118%",
                      },
                      "& .rolist__iimg": {
                        width: "220px",
                        flex: "0 0 220px",
                        height: "164px",
                        background: "rgb(var(--white))",
                        border: "1px solid rgb(var(--light) / 0.50)",
                        "& > .single__img": {
                          padding: "10px",
                        },
                      },
                      "& .rolist__icontent": {
                        width: "calc(100% - 220px)",
                      },
                    },
                    "& .rolist__iaction": {
                      rowGap: "16px",
                    },
                  },
                },
                // org__grid
                "&.org__grid": {
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  marginBottom: "-1px",
                  [breakpoints.SCREEN_XS_MIN]: {
                    gridTemplateColumns: "1fr 1fr",
                  },
                  [breakpoints.SCREEN_MD_MIN]: {
                    gridTemplateColumns: "1fr 1fr 1fr",
                  },
                  "& .rolist__items": {
                    paddingRight: "14px",
                    flexDirection: "column",
                    borderRight: "1px solid rgb(var(--light))",
                    "&:nth-child(2n + 2)": {
                      [breakpoints.SCREEN_MD_MAX]: {
                        borderRight: "0",
                      },
                    },
                    [breakpoints.SCREEN_XS_MAX]: {
                      borderRight: "0",
                    },
                    "& .rolist__igallary": {
                      gap: "10px",
                      height: "auto",
                      width: "100%",
                      paddingBottom: "14px",
                      flexDirection: "column",
                      borderBottom: "1px solid rgb(var(--light))",
                      "& .click__here": {
                        width: "109.5%",
                        height: "103.5%",
                      },
                      "& .rolist__iimg": {
                        width: "100%",
                        flex: "0 0 164px",
                        height: "100%",
                        background: "rgb(var(--white))",
                        "& > .single__img": {
                          padding: "10px",
                        },
                      },
                      "& .rolist__icontent": {
                        width: "100%",
                        "& .icontent__top": {
                          "& .icontent__tbrand": {
                            position: "absolute",
                            top: "-48px",
                            right: "8px",
                            padding: "7px",
                            borderRadius: "6px",
                            backgroundColor: "rgb(var(--white))",
                            border: "1px solid rgb(var(--light) / 0.10)",
                            boxShadow: "0 0 10px rgb(var(--black) / 0.10)",
                          },
                        },
                      },
                    },
                    "& .rolist__iaction": {
                      marginTop: "auto",
                      rowGap: "10px",
                    },
                  },
                },
              },
            },
            "& .card__rpagination": {
              paddingTop: "16px",
              "& .card__rpmiddle": {
                borderRadius: "8px",
                border: "1px solid rgb(var(--light))",
                boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
                "& .pagination": {
                  backgroundColor: "rgb(var(--white))",
                  borderRadius: "8px",
                  marginBottom: "0",
                  padding: "8px",
                  "& .page-item": {
                    "& .page-link": {
                      border: "0",
                      padding: "2px",
                      fontSize: "15px",
                      maxWidth: "max-content",
                      minWidth: "26px",
                      height: "26px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "var(--fw-500)",
                      borderRadius: "4px",
                      color: "rgb(var(--gray) / 0.70)",
                      "&:hover": {
                        color: "rgb(var(--gray))",
                        backgroundColor: "rgb(var(--gray) / 0.10)",
                      },
                      "&:focus": {
                        boxShadow: "none !important",
                        backgroundColor: "rgb(var(--gray) / 0.10)",
                      },
                    },
                    "&:not(:last-child)": {
                      marginRight: "4px",
                    },
                    "&.active": {
                      "& .page-link": {
                        backgroundColor: "rgb(var(--dark))",
                        color: "rgb(var(--white))",
                      },
                    },
                    "&.disabled": {
                      cursor: "not-allowed",
                      "& .page-link": {
                        backgroundColor: "transparent",
                      },
                    },
                  },
                },
              },
              "& .card__rpright": {
                "& > select": {
                  fontSize: "14px",
                  color: "rgb(var(--gray))",
                  fontWeight: "var(--fw-500)",
                  backgroundColor: "rgb(var(--white))",
                  borderRadius: "8px",
                  minHeight: "40px",
                  border: "1px solid rgb(var(--light))",
                  boxShadow: "0 0 12px rgb(var(--black) / 0.03)",
                },
              },
            },
          },
        },
      },
    },
    // mob__filter
    "& .mob__filter": {
      position: "fixed",
      left: "0",
      right: "0",
      bottom: "52px",
      zIndex: "9",
      [breakpoints.SCREEN_LG_MIN]: {
        display: "none",
      },
      "& .mob__inner": {
        "& .mon__filtered": {
          "&:after": {
            content: '""',
            width: "8px",
            height: "8px",
            borderRadius: "50rem",
            backgroundColor: "rgb(var(--success))",
            position: "absolute",
            top: "4px",
            right: "12px",
          },
        },
      },
    },
    // footerCommon
    "& .footerCommon": {
      borderTop: "1px solid rgb(var(--light))",
      backgroundColor: "rgb(var(--white))",
    },

    // orglist__mtc
    "&.orglist__mtc": {
      // headerCommon
      "& .headerCommon": {
        "& .btn-link": {
          color: "rgb(var(--dark))",
        },
      },
      // orgl__section
      "& .orgl__section": {
        minHeight: "calc(100vh - 216px)",
        "& .orgl__list": {
          "& .orgl__left": {
            "& .orgll__inner": {
              "& .card__lbox": {
                // cb__title
                "& .cb__title": {
                  [breakpoints.SCREEN_LG_MAX]: {
                    backgroundColor: "rgb(var(--gray))",
                  },
                  "& p": {
                    [breakpoints.SCREEN_LG_MAX]: {
                      color: "rgb(var(--white))",
                    },
                  },
                  "& .btn-close": {
                    [breakpoints.SCREEN_LG_MAX]: {
                      filter: "invert(1)",
                    },
                  },
                },
                // accordion
                "& .cb__body": {
                  [breakpoints.SCREEN_LG_MAX]: {
                    maxHeight: "calc(100vh - 45px)",
                  },
                },
              },
            },
          },
        },
      },
    },

    // orglist__clinks
    "&.orglist__clinks": {
      // headerCommon
      "& .headerCommon": {
        "& .btn-link": {
          color: "rgb(var(--white)) !important",
        },
      },
      // orgl__section
      "& .orgl__section": {
        minHeight: "calc(100vh - 136px)",
        "& .orgl__list": {
          "& .orgl__left": {
            "& .orgll__inner": {
              // cust___search
              "& .cust___search": {
                "& .mobf__title": {
                  "& .mobf__inner": {
                    [breakpoints.SCREEN_LG_MIN]: {
                      padding: "16px",
                      borderBottom: "1px solid rgb(var(--light))",
                    },
                    [breakpoints.SCREEN_LG_MAX]: {
                      padding: "10px 14px",
                      backgroundColor: "rgb(var(--gray))",
                    },
                    "& > p": {
                      [breakpoints.SCREEN_LG_MAX]: {
                        color: "rgb(var(--white))",
                      },
                    },
                    "& .btn-close": {
                      [breakpoints.SCREEN_LG_MAX]: {
                        filter: "invert(1)",
                      },
                    },
                  },
                },
                "& .card__lbox": {
                  "& .custs___inner": {
                    padding: "16px",
                    [breakpoints.SCREEN_LG_MAX]: {
                      borderBottom: "1px solid rgb(var(--light))",
                    },
                    "& .custs___form": {
                      "& input": {
                        paddingRight: "50px !important",
                      },
                      "& > .search__btn": {
                        width: "40px",
                        flex: "0 0 40px",
                        height: "40px",
                        position: "absolute",
                        right: "6px",
                        top: "6px",
                      },
                      "& > .reset__search": {
                        width: "40px",
                        flex: "0 0 40px",
                        height: "40px",
                        position: "absolute",
                        right: "6px",
                        top: "6px",
                        "& > svg": {
                          "& > path": {
                            color: "rgb(var(--danger))",
                          },
                        },
                      },
                    },
                    "& .search__results": {},
                  },
                },
                "& .cust___or": {
                  [breakpoints.SCREEN_LG_MAX]: {
                    backgroundColor: "rgb(var(--gray-90))",
                  },
                  "&:before, &:after": {
                    content: '""',
                    width: "50%",
                    height: "1px",
                    opacity: "0.70",
                    display: "inline-flex",
                  },
                  "&:before": {
                    background:
                      "linear-gradient(-90deg, rgb(var(--gray-300)), transparent)",
                  },
                  "&:after": {
                    background:
                      "linear-gradient(90deg, rgb(var(--gray-300)), transparent)",
                  },
                  "& > small": {
                    color: "rgb(var(--gray))",
                  },
                },
              },
              "& .card__lbox": {
                // cb__title
                "& .cb__title": {
                  [breakpoints.SCREEN_LG_MAX]: {
                    borderTop: "1px solid rgb(var(--light))",
                  },
                },
                // accordion
                "& .cb__body": {
                  [breakpoints.SCREEN_LG_MAX]: {
                    maxHeight: "calc(100dvh - 100px)",
                    paddingBottom: "130px",
                  },
                },
              },
            },
          },
        },
      },
    },
  },
});
